module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="' +
((__t = (id)) == null ? '' : __t) +
'" class="DescartesModal modal fade" role="dialog">\n    <div class="modal-dialog ' +
((__t = (size)) == null ? '' : __t) +
'" role="document">\n        <!-- Modal content-->\n        <div class="modal-content">\n            ';
 if (isContentForm) { ;
__p += '\n            <form id="' +
((__t = (id)) == null ? '' : __t) +
'_formDialog" class="' +
((__t = (formClass)) == null ? '' : __t) +
'">\n            ';
 };
__p += '\n                <div class="modal-header">\n                     <h4 class="DescartesModalTitle modal-title">' +
((__t = (title)) == null ? '' : __t) +
'</h4>\n                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">\n                        <span aria-hidden="true">&times;</span>\n                    </button>\n                </div>\n                <div class="modal-body" style="overflow: auto;max-height: ' +
((__t = (maxHeight)) == null ? '' : __t) +
'px">\n                    ' +
((__t = (content)) == null ? '' : __t) +
'\n                </div>\n            ';
 if (!isContentForm) { ;
__p += '\n            <form id="' +
((__t = (id)) == null ? '' : __t) +
'_formDialog" class="' +
((__t = (formClass)) == null ? '' : __t) +
'">\n            ';
 };
__p += '\n                <div class="modal-footer">\n                    <button type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" data-dismiss="modal">Annuler</button>\n                    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (sendLabel)) == null ? '' : __t) +
'</button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ModalFormDialog.ejs
// module id = 316
// module chunks = 0